import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin: 80px auto;
  max-width: 1366px;
  padding-inline: 24px;
  width: 100%;

  @media (max-width: 568px) {
    margin-block: 62px 72px;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
  margin-inline: auto;
  max-width: 1008px;
  width: 100%;

  @media (max-width: 568px) {
    gap: 62px;
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 494px;

  & > h1 {
    color: #013C1A;
    font-size: 2.5rem;
    font-weight: 700;
  }

  @media (max-width: 568px) {
    gap: 24px;

    & > h1 {
      font-size: 1.5rem;
    }
  }
`

export const Form = styled.form`
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(auto-fill, minmax(calc(min(296px, 100%)), 1fr));

  div:has(input[type="checkbox"]) {
    grid-column: 1 / -1;
  }

  & > button {
    max-width: 296px;
    padding: 12px 32px;
  }

  @media (max-width: 568px) {
    & > button {
      margin-top: 16px;
      max-width: 100%;
    }
  }
`

export const Error = styled.div`
  color: #cc0000;
  font-size: 0.75rem;
  margin-left: 16px;
  margin-top: 8px;
`
